import * as React from 'react';
import Svg, { Rect, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => {
    const stroke = props.fill ?? designSystem.colors.neutral300;
    return (
        <Svg width={24} height={24} viewBox="0 0 24 24" {...props} fill="none">
            <Rect
                x={4}
                y={4}
                width={6.15323}
                height={6.15323}
                rx={1.15373}
                stroke={stroke}
                strokeWidth={1.6826}
                strokeLinejoin="bevel"
            />
            <Rect
                x={13.8467}
                y={4}
                width={6.15323}
                height={6.15323}
                rx={1.15373}
                stroke={stroke}
                strokeWidth={1.6826}
                strokeLinejoin="bevel"
            />
            <Rect
                x={4}
                y={13.8467}
                width={6.15323}
                height={6.15323}
                rx={1.15373}
                stroke={stroke}
                strokeWidth={1.6826}
                strokeLinejoin="bevel"
            />
            <Rect
                x={13.8467}
                y={13.8467}
                width={6.15323}
                height={6.15323}
                rx={1.15373}
                stroke={stroke}
                strokeWidth={1.6826}
                strokeLinejoin="bevel"
            />
        </Svg>
    );
};
export { SvgComponent as VaultIcon };
